import get from 'lodash/get';
import { setWindowLocation } from 'js-utils/http';
import { HAS_WINDOW } from '@eb/feature-detection';
import { parseQuery } from 'url-lib';
import {
    events as eventsDuck,
    collections as collectionsDuck,
} from '@eb/destination-utils';
import {
    getCollectionEvents as getCollectionEventsApi,
    getCollectionEventsWithSearch as getCollectionEventsWithSearchApi,
} from '../api/events';
import {
    BROWSE_EVENTS_PATH,
    EDITORIAL_COLLECTION_PAGE_GA_CATEGORY,
    COLLECTION_PAGE_GA_CATEGORY,
    BROWSE_EVENTS_GA_ACTION,
} from '../constants';
import { setError } from './index';

const {
    api: {
        saveEvent: saveEventApi,
        unsaveEvent: unsaveEventApi,
        loggedOutSaveRedirect,
    },
    utils: { transformForRedux },
    actionTypes: { SET_EVENTS, SET_EVENT_SAVED_STATE },
} = eventsDuck;

const {
    actionTypes: { BROWSE_EVENTS },
} = collectionsDuck;

/* Event save and unsave actions */
export const setLikeState = (eventId, saveState) => ({
    type: SET_EVENT_SAVED_STATE,
    payload: {
        eventId,
        saveState,
    },
});

export const clickOnLikeToggle = (eventId, shouldLike) => (
    dispatch,
    getState,
) => {
    const { isAuthenticated } = getState();

    if (!isAuthenticated) {
        let location = '/';

        if (HAS_WINDOW) {
            location = {
                pathname: window.location.pathname,
                query: parseQuery(window.location.search),
            };
        }

        return loggedOutSaveRedirect(eventId, location);
    }

    let likeApiCall = unsaveEventApi;

    if (shouldLike) {
        likeApiCall = saveEventApi;
    }

    return likeApiCall(eventId).then(
        () => {
            dispatch(setLikeState(eventId, shouldLike));

            return 'success';
        },
        () => dispatch(setError()),
    );
};

/* Event get and set actions */
export const SET_UPCOMING_EVENTS = 'userCollection/upcomingEvents/';
export const EVENTS_LOADING = 'userCollection/eventsLoading';

const setUpcomingEventData = (data) => ({
    payload: data,
    type: SET_UPCOMING_EVENTS,
});

const setEvents = (data) => ({
    type: SET_EVENTS,
    payload: data,
});

const eventsLoading = (isLoading) => ({
    type: EVENTS_LOADING,
    payload: isLoading,
});

const fetchAndUpdateEvents = ({
    dispatch,
    id,
    continuation,
    secret,
    getCollectionEventsWithSearch,
}) => {
    const getEventsApi = getCollectionEventsWithSearch
        ? getCollectionEventsWithSearchApi
        : getCollectionEventsApi;

    return getEventsApi({ id, continuation, secret }).then(
        (response) => {
            let responseToParse = response;

            if (getCollectionEventsWithSearch) {
                responseToParse = {
                    events: get(response, ['events', 'results']),
                    pagination: get(response, ['events', 'pagination']),
                };
            }

            const { events, ...requestData } = transformForRedux(
                responseToParse,
            );

            dispatch(setEvents({ events }));
            dispatch(setUpcomingEventData(requestData));
        },
        () => dispatch(setError()),
    );
};

const getEvents = () => (dispatch, getState) => {
    const {
        collection: { id, secret, getCollectionEventsWithSearch },
        events: {
            upcoming: { continuation },
        },
    } = getState();

    dispatch(eventsLoading(true));

    return fetchAndUpdateEvents({
        dispatch,
        id,
        continuation,
        secret,
        getCollectionEventsWithSearch,
    }).catch((e) => {
        if (e && e.parsedError && e.parsedError.error === 'BAD_PAGE') {
            // fetch first page again
            return fetchAndUpdateEvents(dispatch);
        }

        return Promise.resolve();
    });
};

export const clickOnSeeMoreEvents = () => (dispatch) => {
    dispatch(getEvents());
};

const trackBrowseEvents = (isEditorial) => ({
    type: BROWSE_EVENTS,
    meta: {
        analytics: {
            category: isEditorial
                ? EDITORIAL_COLLECTION_PAGE_GA_CATEGORY
                : COLLECTION_PAGE_GA_CATEGORY,
            action: BROWSE_EVENTS_GA_ACTION,
        },
    },
});

export const clickOnBrowseEvents = () => (dispatch, getState) => {
    const {
        collection: { isQuality },
    } = getState();

    setWindowLocation(BROWSE_EVENTS_PATH);
    dispatch(trackBrowseEvents(isQuality));
};
